import { createStore, createEvent, createEffect, combine } from 'effector';
import request from '@helpers/request';
import api from '@constants/endpoints';
import { get } from 'lodash';
import { PaginationProps } from 'antd/lib/pagination';
import createPaginationStore from './pagination';
import createPreloadersStore from './preloaders';
import createFiltersStore from './filters';
import removeUndefinedFilters from '@helpers/removeUndefinedFilters';

export const reset = createEvent('Experiments store reset');

const defaultFilters = {
  sort: 'active,desc',
};

export const getList = createEffect({
  name: 'getList',
  async handler(params?: {
    pagination?: PaginationProps;
    filters?: Record<string, any>;
    sort?: string;
  }) {
    const paginationParams = {
      ...pagination.getState(),
      ...params?.pagination,
    };

    let filtersParams = filters.getState();

    if (params?.filters) {
      setFilters(params.filters);
      filtersParams = params.filters;
      paginationParams.current = 1;
    }

    const requestParams = {
      paged: true,
      page: (paginationParams.current || 1) - 1,
      size: paginationParams.pageSize || 20,
      ...defaultFilters,
      ...removeUndefinedFilters(filtersParams),
      ...(params?.sort ? { sort: params.sort } : {}),
    };

    const response = await request(api.experiments.getList, {
      params: requestParams,
    });

    return response;
  },
});

const { pagination, setPagination } = createPaginationStore({
  getList,
  listName: 'experiments',
  resetEvent: reset,
  bodyPath: ['data', 'body'],
});

export { setPagination };

const preloaders = createPreloadersStore([getList]);

const { filters, setFilters } = createFiltersStore({
  listName: 'experiments',
  deaultValues: defaultFilters,
  resetEvent: reset,
});

export { setFilters };

const list = createStore<any[]>([])
  .on(getList.done, (_, { result }) => get(result, ['data', 'body', 'content'], []))
  .reset(reset);

const experiments = combine({
  preloaders,
  list,
  pagination,
  filters,
});

export default experiments;
